/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import {
	ArrowLargeLIcon,
	ArrowLargeRIcon,
	ArrowMediumLIcon,
	ArrowMediumRIcon,
	ArrowSmallLIcon,
	ArrowSmallRIcon,
	CloseIcon,
	CloseSmallIcon,
	EllipsisIcon,
	FilterIcon,
	IconFlash,
} from '@src/components/Icon';
import ListingPopover from '@src/components/ListingPopover/component';
import NLink from '@src/components//NLink';
import usePopover from '@src/libs/hooks/usePopover';
import css from './style.module.scss';

/** Deprecated. Use Btn component instead */
const Button = ({
	Icon,
	icon,
	mods,
	label,
	ariaLabel,
	isDisabled,
	isSubmit,
	onClick,
	children,
	href,
	linkProps,
	badge,
	isDotBadge,
	className,
	full: _full,
	...attr
}) => {
	const Wrap = href ? 'a' : 'button';

	const node = (
		<Wrap
			className={cn('button', mods, className, {
				disabled: isDisabled,
				badged: Boolean(badge) || isDotBadge,
				dot: isDotBadge,
			})}
			disabled={isDisabled}
			type={isSubmit ? 'submit' : 'button'}
			{...attr}
			aria-label={ariaLabel || label}
			onClick={onClick}
		>
			{Icon && <Icon />}
			{icon}
			{label && <span>{label}</span>}
			{badge && <sup className="badge">{badge}</sup>}
			{children}
		</Wrap>
	);

	if (href) {
		return (
			<NLink href={href} {...linkProps}>
				{node}
			</NLink>
		);
	}

	return node;
};

Button.propTypes = {
	/**
	 * Стилевые модификаторы кнопки.
	 */
	mods: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.string,
	]),
	/**
	 * Обработчик клика по кнопке.
	 */
	onClick: PropTypes.func,
	/**
	 * Текст кнопки.
	 */
	label: PropTypes.string,
	/**
	 * Контроллер отключения/включения кнопки.
	 */
	isDisabled: PropTypes.bool,
	/**
	 * Является ли кнопка подтверждением формы?
	 */
	isSubmit: PropTypes.bool,
	/**
	 * Текст кнопки для читателей экрана и других вспомогательных технологий.
	 */
	ariaLabel: PropTypes.string,
	/**
	 * Компонент иконки.
	 */
	Icon: PropTypes.elementType,
	icon: PropTypes.element,
	/**
	 * Дочерние элементы. Используется для поповеров и прочего.
	 */
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
	/**
	 * Ссылка, при наличии элемент использует тег `<a>`
	 */
	href: PropTypes.string,
	linkProps: PropTypes.shape({ ...NLink.propTypes }),
	/**
	 * Текст значка (элемента в верхнем правом углу кнопки).
	 */
	badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	/**
	 * Использовать ли значок в виде точки (имеет приоритет над `badge`).
	 */
	isDotBadge: PropTypes.bool,
	/**
	 *
	 */
	className: PropTypes.string,
};

Button.defaultProps = {
	label: undefined,
	mods: [],
	onClick: undefined,
	isDisabled: false,
	isSubmit: false,
	ariaLabel: undefined,
	Icon: undefined,
	icon: undefined,
	children: [],
	href: undefined,
	linkProps: undefined,
	badge: undefined,
	isDotBadge: false,
	className: undefined,
};

export const BlackMedium = (props) => (
	<Button mods={['medium', 'black', 'round', 'bold']} {...props} />
);
BlackMedium.defaultProps = {
	label: 'Перейти',
};

export const WhiteMediumArrowL = (props) => (
	<Button
		Icon={ArrowMediumLIcon}
		{...props}
		mods={cn(cn(props.mods), [
			'medium',
			'round',
			'fix',
			'white',
			'shadow',
			'border',
			'left',
		])}
	/>
);

export const WhiteMediumArrowR = (props) => (
	<Button
		Icon={ArrowMediumRIcon}
		{...props}
		mods={cn(props.mods, [
			'medium',
			'round',
			'fix',
			'white',
			'shadow',
			'border',
			'right',
		])}
	/>
);

export const WhiteXSmallArrowR = (props) => (
	<Button
		Icon={ArrowSmallRIcon}
		{...props}
		mods={cn(props.mods, [
			'x-small',
			'white',
			'round',
			'fix',
			'border',
			'right',
		])}
	/>
);

export const WhiteXSmallArrowL = (props) => (
	<Button
		Icon={ArrowSmallLIcon}
		{...props}
		mods={cn(props.mods, [
			'x-small',
			'white',
			'round',
			'fix',
			'border',
			'left',
		])}
	/>
);

export const InputClear = (props) => (
	<Button {...props} Icon={CloseSmallIcon} />
);

export const PagingSwitch = (props) => (
	<Button {...props} mods={['small', 'round', 'grey']} />
);
PagingSwitch.defaultProps = {
	label: '1',
};

export const PagingSwitchEllipsis = (props) => {
	const { children: btnChildren } = props;
	const { popover, isPopoverOpen, setPopoverOpen } = usePopover(false);

	return (
		<Button
			{...props}
			mods={['small', 'round', 'border', 'more', 'ls-popover-tag']}
			Icon={EllipsisIcon}
			onClick={() => {
				setPopoverOpen(true);
			}}
		>
			{btnChildren && isPopoverOpen && (
				<ListingPopover
					mods={['posB', 'dirL']}
					isOpen={isPopoverOpen}
					ref={popover}
				>
					{btnChildren}
				</ListingPopover>
			)}
		</Button>
	);
};
PagingSwitchEllipsis.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
};
PagingSwitchEllipsis.defaultProps = {
	children: [],
};

export const WhiteXLargeArrowL = (props) => (
	<Button
		mods={['x-large', 'white', 'round', 'fix', 'border', 'left']}
		Icon={ArrowLargeLIcon}
		{...props}
	/>
);

export const BlackLargeClose = (props) => {
	// type: dark
	const { type, ...rest } = props;
	return (
		<Button
			mods={cn(css.roundBtn, { [css[`roundBtn_type_${type}`]]: !!type })}
			icon={<CloseIcon mods={css.icon} />}
			{...rest}
		/>
	);
};

export const WhiteXLargeArrowR = (props) => (
	<Button
		mods={['x-large', 'white', 'round', 'fix', 'border', 'right']}
		Icon={ArrowLargeRIcon}
		{...props}
	/>
);

export const BlackPurpleMedium = (props) => (
	<Button mods={['medium', 'black-purple', 'round', 'bold']} {...props} />
);
BlackPurpleMedium.defaultProps = {
	label: 'Применить',
};

export const GreenWhiteFlashMedium = (props) => (
	<Button
		mods={['medium green shadow round extra-bold']}
		Icon={IconFlash}
		{...props}
	/>
);
GreenWhiteFlashMedium.defaultProps = {
	label: 'Позвонить',
};

export const WhiteMedium = (props) => (
	<Button mods={['medium white shadow round']} {...props} />
);
WhiteMedium.defaultProps = {
	label: 'Заявка',
};

export const WhitePurpleXSmallFilter = (props) => (
	<Button
		mods="white-purple x-small round narrow manage-filters"
		Icon={FilterIcon}
		{...props}
	/>
);

WhitePurpleXSmallFilter.defaultProps = {
	label: 'Фильтры',
};

export const WhitePurpleResponsiveFilter = (props) => (
	<Button
		mods="white-purple only-border header-filter narrow"
		Icon={FilterIcon}
		{...props}
	/>
);

WhitePurpleResponsiveFilter.defaultProps = {
	label: 'Фильтры',
	badge: '2',
};

export const WhiteRedXXSmall = (props) => (
	<Button mods={cn('white-red xx-small', props.className)} {...props} />
);
WhiteRedXXSmall.defaultProps = {
	label: 'Сбросить',
};

export const PurpleMedium = (props) => (
	<Button mods="purple medium round bold" {...props} />
);
PurpleMedium.defaultProps = {
	label: 'Применить',
};

export const TransparentRedMedium = (props) => (
	<Button mods="transparent-red medium" {...props} />
);
TransparentRedMedium.defaultProps = {
	label: 'Сбросить всё',
};

export const WhitePurpleSmall = (props) => (
	<Button
		mods={cn(
			css.block,
			css['block_appearance_white-purple'],
			css.block_size_small,
		)}
		{...props}
	/>
);
WhitePurpleSmall.defaultProps = {
	label: 'Сбросить все фильтры',
};

export default Button;
